import { fmtDate } from "utils/date";
import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Badge,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import { BuzonDudasService } from "service/BuzonDudasService";

const buzonService = new BuzonDudasService();

const ModalRespuestaDuda = ({ isOpen, toggle, selectedPregunta, onSave }) => {
  const [respuesta, setRespuesta] = useState("");
  const [editando, setEditando] = useState(null); // { id, texto }
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setRespuesta("");
      setEditando(null);
    }
  }, [isOpen]);

  const handleEnviar = async () => {
    if (!respuesta.trim()) {
      alert("Escribe una respuesta");
      return;
    }
    setLoading(true);
    try {
      if (editando) {
        await buzonService.updateRespuesta(selectedPregunta._id, editando.id, {
          respuesta,
        });
      } else {
        await buzonService.addRespuesta(selectedPregunta._id, { respuesta });
      }
      setRespuesta("");
      setEditando(null);
      onSave();
      toggle();
    } catch (error) {
      console.error("Error enviando respuesta:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleEditarRespuesta = (resp) => {
    setEditando({ id: resp._id, texto: resp.respuesta });
    setRespuesta(resp.respuesta);
  };

  const cancelarEdicion = () => {
    setEditando(null);
    setRespuesta("");
  };

  if (!selectedPregunta) return null;

  const respuestas = selectedPregunta.respuestas || [];

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" backdrop="static">
      <ModalHeader toggle={toggle}>
        Detalle de Duda{" "}
        <Badge color={selectedPregunta.estado === "Respondido" ? "success" : "warning"}>
          {selectedPregunta.estado}
        </Badge>
      </ModalHeader>
      <ModalBody>
        <div className="mb-3 p-3 border rounded">
          <small className="text-muted">
            {selectedPregunta.fecha
              ? fmtDate(selectedPregunta.fecha)
              : ""}{" "}
            {selectedPregunta.alumno?.nombres && `— ${selectedPregunta.alumno.nombres}`}
          </small>
          <p className="mt-1 mb-0">{selectedPregunta.pregunta}</p>
        </div>

        {respuestas.length > 0 && (
          <div className="mb-3">
            <Label>Respuestas anteriores:</Label>
            <ListGroup>
              {respuestas.map((r) => (
                <ListGroupItem key={r._id} className="d-flex justify-content-between align-items-start">
                  <span>{r.respuesta}</span>
                  <Button
                    color="info"
                    size="sm"
                    className="btn-icon btn-link ml-2"
                    title="Editar respuesta"
                    onClick={() => handleEditarRespuesta(r)}
                  >
                    <i className="tim-icons icon-pencil" />
                  </Button>
                </ListGroupItem>
              ))}
            </ListGroup>
          </div>
        )}

        <FormGroup>
          <Label>{editando ? "Editar respuesta" : "Nueva respuesta"}</Label>
          <Input
            type="textarea"
            rows="4"
            value={respuesta}
            onChange={(e) => setRespuesta(e.target.value)}
            placeholder="Escribe tu respuesta..."
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        {editando && (
          <Button color="secondary" onClick={cancelarEdicion}>
            Cancelar edición
          </Button>
        )}
        <Button color="secondary" onClick={toggle}>
          Cerrar
        </Button>
        <Button color="primary" onClick={handleEnviar} disabled={loading}>
          {editando ? "Actualizar" : "Responder"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalRespuestaDuda;
